import React from 'react';

const UIDemo = () => {
    return (
        <div className="container">
            <h1>Démo des éléments d'interface</h1>
            
            {/* Typographie */}
            <section className="panel" style={{marginBottom: '30px'}}>
                <h2>Typographie</h2>
                <h1>Titre h1</h1>
                <h2>Titre h2</h2>
                <h3>Titre h3</h3>
                <h4>Titre h4</h4>
                <h5>Titre h5</h5>
                <h6>Titre h6</h6>
                <p>Paragraphe standard avec la police principale (var(--main-font))</p>
                <p>Un autre paragraphe avec du texte plus long. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Sed euismod, nisl vel ultricies lacinia, nisl nisl aliquam nisl, eu aliquam nisl nisl eu nisl.</p>
            </section>

            {/* Boutons */}
            <section className="panel" style={{marginBottom: '30px'}}>
                <h2>Boutons</h2>
                
                <h3>Boutons standards</h3>
                <div style={{display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap'}}>
                    <button>Bouton standard</button>
                    <button disabled>Bouton désactivé</button>
                </div>

                <h3>Boutons avec icônes</h3>
                <div style={{display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap'}}>
                    <button><span className="icon">★</span> Avec icône</button>
                </div>
            </section>

            {/* Formulaires */}
            <section className="panel" style={{marginBottom: '30px'}}>
                <h2>Éléments de formulaire</h2>
                
                <div className="form-group">
                    <label htmlFor="text-input">Champ texte</label>
                    <input type="text" id="text-input" placeholder="Entrez du texte..." />
                </div>

                <div className="form-group">
                    <label htmlFor="text-input-disabled">Champ texte désactivé</label>
                    <input type="text" id="text-input-disabled" placeholder="Champ désactivé" disabled />
                </div>

                <div className="form-group">
                    <label htmlFor="textarea">Zone de texte</label>
                    <textarea id="textarea" rows="4" placeholder="Entrez un texte plus long..."></textarea>
                </div>

                <div className="form-group">
                    <label htmlFor="select">Menu déroulant</label>
                    <select id="select">
                        <option value="">Sélectionnez une option</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </select>
                </div>
                
                <div className="form-group">
                    <fieldset>
                        <legend>Options (radio buttons)</legend>
                        <div>
                            <input type="radio" id="radio1" name="radio-group" value="option1" />
                            <label htmlFor="radio1">Option 1</label>
                        </div>
                        <div>
                            <input type="radio" id="radio2" name="radio-group" value="option2" />
                            <label htmlFor="radio2">Option 2</label>
                        </div>
                    </fieldset>
                </div>
                
                <div className="form-group">
                    <fieldset>
                        <legend>Choix multiples (checkboxes)</legend>
                        <div>
                            <input type="checkbox" id="check1" name="check1" />
                            <label htmlFor="check1">Option A</label>
                        </div>
                        <div>
                            <input type="checkbox" id="check2" name="check2" />
                            <label htmlFor="check2">Option B</label>
                        </div>
                    </fieldset>
                </div>
            </section>

            {/* Éléments HTML de base */}
            <section className="panel" style={{marginBottom: '30px'}}>
                <h2>Éléments HTML de base</h2>
                
                <h3>Liens</h3>
                <p>Voici un <a href="#">exemple de lien</a> dans un paragraphe.</p>
                
                <h3>Éléments de texte inline</h3>
                <p>
                    <strong>Texte important (strong)</strong>, <em>Texte mis en emphase (em)</em>, <mark>Texte marqué (mark)</mark>, 
                    <small>Petit texte (small)</small>, <del>Texte supprimé (del)</del>, <ins>Texte inséré (ins)</ins>, 
                    <sub>Indice (sub)</sub>, <sup>Exposant (sup)</sup>, <code>Code inline (code)</code>, <kbd>Touche clavier (kbd)</kbd>, 
                    <abbr title="Abréviation">Abbr</abbr>
                </p>
                
                <h3>Bloc de code</h3>
                <pre><code>
{`function helloWorld() {
    console.log("Hello World!");
}`}
                </code></pre>
                
                <h3>Citations</h3>
                <blockquote>
                    Ceci est une citation en bloc (blockquote). Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    <cite>Source de la citation</cite>
                </blockquote>
                <p>Voici une <q>citation inline (q)</q> dans un paragraphe.</p>
                
                <h3>Listes ordonnées</h3>
                <ol>
                    <li>Premier élément</li>
                    <li>Deuxième élément</li>
                    <li>Troisième élément
                        <ol>
                            <li>Sous-élément 1</li>
                            <li>Sous-élément 2</li>
                        </ol>
                    </li>
                </ol>
                
                <h3>Listes non-ordonnées</h3>
                <ul>
                    <li>Élément de liste</li>
                    <li>Autre élément</li>
                    <li>Dernier élément
                        <ul>
                            <li>Sous-élément</li>
                            <li>Autre sous-élément</li>
                        </ul>
                    </li>
                </ul>
                
                <h3>Listes de définition</h3>
                <dl>
                    <dt>Terme à définir</dt>
                    <dd>Définition du terme.</dd>
                    <dt>Autre terme</dt>
                    <dd>Autre définition.</dd>
                </dl>
                
                <h3>Tableaux</h3>
                <table>
                    <caption>Titre du tableau</caption>
                    <thead>
                        <tr>
                            <th>En-tête 1</th>
                            <th>En-tête 2</th>
                            <th>En-tête 3</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Cellule 1</td>
                            <td>Cellule 2</td>
                            <td>Cellule 3</td>
                        </tr>
                        <tr>
                            <td>Cellule 4</td>
                            <td>Cellule 5</td>
                            <td>Cellule 6</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="3">Pied de tableau</td>
                        </tr>
                    </tfoot>
                </table>
                
                <h3>Images</h3>
                <figure>
                    <img src="https://via.placeholder.com/300x200" alt="Image d'exemple" />
                    <figcaption>Légende de l'image</figcaption>
                </figure>
                
                <h3>Séparateurs</h3>
                <hr />
                <p>Texte après un séparateur horizontal</p>
                
                <h3>Détails/Sommaire</h3>
                <details>
                    <summary>Cliquez pour afficher plus d'informations</summary>
                    <p>Contenu caché qui apparaît lorsqu'on clique sur le sommaire.</p>
                </details>
                
                <h3>Barre de progression</h3>
                <label>Progression à 70%:</label>
                <progress value="70" max="100">70%</progress>
                
                <h3>Mètre</h3>
                <label>Niveau à 0.6:</label>
                <meter value="0.6" min="0" max="1">60%</meter>
            </section>

            {/* Messages */}
            <section className="panel" style={{marginBottom: '30px'}}>
                <h2>Messages</h2>
                
                <div className="error-message">
                    Ceci est un message d'erreur.
                </div>

                <div className="success-message">
                    Ceci est un message de succès.
                </div>
            </section>

            {/* Panneaux */}
            <section style={{marginBottom: '30px'}}>
                <h2>Panneaux</h2>
                
                <h3>Panel standard</h3>
                <div className="panel" style={{marginBottom: '20px'}}>
                    <p>Contenu dans un panneau avec bordure et ombre.</p>
                </div>

                <h3>Invisible panel (pour les écrans {'>'}768px)</h3>
                <div className="invisible-panel">
                    <p>Contenu dans un panneau invisible avec padding uniquement sur les côtés.</p>
                </div>
            </section>
        </div>
    );
};

export default UIDemo; 